/*
 * Copyright (c) 2023 Bolmate B.V.
 */

import React, {useContext, useState} from "react";
import {navigate, ResponseData, showDialog} from '@dvrd/dvr-controls';
import {onGlobalLoad, onLogout} from "../../util/events";
import Header from "./header";
import {AppContext} from "../misc/appContext";
import {logout} from "../../util/requestSender";
import {deleteFromAppLocal, deleteFromLocal} from "../../util/storageUtil";
import {setGaUserId} from "../../util/analytics";
import {INVOICES_ROUTE, REGISTER_ROUTE, SELECTED_ACCOUNT_KEY, SUBSCRIPTION_ROUTE} from "../../util/constants";
import {requestPageChangePermission} from "../../util/pageChanger";

interface Props {
    menuWidth: number;
}

export default function HeaderController(props: Props) {
    const context = useContext(AppContext);
    const {menuWidth} = props;
    const isDemo = context.userContext.user?.isDemoAccount ?? false;
    const [upgradeClicked, setUpgradeClicked] = useState<boolean>(false)

    function onClickLogo() {
        requestPageChangePermission(() => {
            navigate(INVOICES_ROUTE);
        });
    }

    function onClickUpgrade() {
        requestPageChangePermission(() => {
            navigate(SUBSCRIPTION_ROUTE)
            setUpgradeClicked(true);
        });
    }

    function onClickLogout() {
        requestPageChangePermission(onLogout);
    }

    function onClickDemoRegister() {
        if (!isDemo) return;
        onGlobalLoad(true);
        logout({
            callback: (data: ResponseData) => {
                onGlobalLoad(false);
                if (data.success) {
                    deleteFromAppLocal('newUser');
                    deleteFromLocal(SELECTED_ACCOUNT_KEY);
                    setGaUserId(null);
                    context.onChangeContext({accounts: [], account: null, user: null}, () => {
                        window.setTimeout(() => {
                            navigate(REGISTER_ROUTE)
                        });
                    });
                } else showDialog('Het uitloggen is niet gelukt.', 'Uitloggen mislukt');
            }
        });
    }

    return (
        <Header onClickLogo={onClickLogo} onClickUpgrade={onClickUpgrade} menuWidth={menuWidth}
                onClickLogout={onClickLogout} onClickDemoRegister={onClickDemoRegister} isDemo={isDemo}
                upgradeClicked={upgradeClicked}/>
    )
}